module.exports = __webpack_public_path__ + "static/media/california-meetings-services.3e21d915.jpg";